import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import {GestaoPcaService} from "../../../providers/gestao-pca-service";

/*
  Generated class for the ModalAdicionarPergunta page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  templateUrl: 'modal-adicionar-pergunta.html'
})
export class ModalAdicionarPerguntaPage {
  PCAAtiva: any;
  objeto: any;
  titulo: any;
  isJurisdicionado: any;
  isCGE: any;
  analistaEditar: boolean = false;
  objetoRetorno: {
    flag: boolean,
    objeto: string
  };

  constructor(private viewCtrl: ViewController, public navParams: NavParams, private gestaoPCAService: GestaoPcaService) {
    this.objetoRetorno = {
      flag: false,
      objeto: ""
    };
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('param2');
    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.analistaEditar = this.navParams.get('analista');
    this.PCAAtiva = this.gestaoPCAService.getPCA();
    this.PCAAtiva.isPCAAberta = this.gestaoPCAService.isPCAAberta();
  }

  dismiss() {
    this.objetoRetorno.flag = false;
    this.viewCtrl.dismiss(this.objetoRetorno);
  }

  salvarEdicacao() {
    this.objetoRetorno.flag = true;
    this.objetoRetorno.objeto = this.objeto;
    this.viewCtrl.dismiss(this.objetoRetorno);
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-adicionar-pergunta/modal-adicionar-pergunta.ts